<template>
    <div class="conditions">
        <v-card v-if="isLoading" color="primary" dark>
            <v-card-title class="px-4 fs-14">
                {{ $t('cancellation_penalties') }}
            </v-card-title>
            <v-card-text class="fs-14">
                <slot name="info" />
                {{ $t('stand_by') }}
                <v-progress-linear indeterminate color="white" class="mb-0" />
            </v-card-text>
        </v-card>
        <v-card v-else :elevation="elevation">
            <v-card-title v-if="!hideTitle" class="px-4 fs-14 text-wrap">
                {{ $t('cancellation_penalties') }}
            </v-card-title>
            <v-icon v-if="!hideCloseBtn" class="v-card-close" @click="$emit('close-modal')">mdi-close</v-icon>
            <div class="px-4 py-0 text--secondary font-weight-thin fs-12">
                <slot name="info" />
            </div>
            <v-list v-if="!hasErrors">
                <template v-if="freeDate">
                    <v-list-item>
                        <v-list-item-title class="text-left">
                            <strong class="text-green font-weight-regular fs-12">
                                {{ $t('before') }}
                                <template v-if="userTimeZone">
                                    {{ $filters.dateTimeFormat($dateFns.addMinutes(freeDate, -1)) }} *
                                </template>
                                <template v-else>
                                    {{ $filters.dateFormat(freeDate) }}
                                </template>
                            </strong>
                        </v-list-item-title>
                        <v-list-item-action class="mr-1">
                            <strong class="text-success font-weight-regular fs-12">
                                {{ $t('cancellation_free') }}
                            </strong>
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider />
                </template>
                <template v-for="(cancellationItem, index) in conditionsInfo.cancellationItems" :key="index">
                    <v-list-item>
                        <v-list-item-title v-if="!cancellationItem.noShow" class="text-left">
                            <strong class="text-red font-weight-regular fs-12">
                                {{ $t('after') }}
                                <template v-if="userTimeZone">
                                    {{ $filters.dateTimeFormat($dateFns.parseISO(cancellationItem.dateFrom)) }} *
                                </template>
                                <template v-else>
                                    {{ $filters.dateFormat($dateFns.parseISO(cancellationItem.dateFrom)) }}
                                </template>
                            </strong>
                        </v-list-item-title>
                        <div v-else class="text--secondary text-left fs-12">
                            <strong>No show</strong>
                            <span>({{ $t('no_show_at_hotel') }})</span>
                        </div>
                        <div
                            v-if="cancellationItem.description"
                            class="text--secondary font-weight-regular fs-12"
                            v-html="cancellationItem.description"
                        />
                        <v-list-item-action v-if="cancellationItem.price && cancellationItem.price.amount" class="mr-1">
                            <strong v-if="disableCurrencyConversion" class="fs-12">
                                {{
                                    $filters.priceFormat(cancellationItem.price.amount, cancellationItem.price.currency)
                                }}
                            </strong>
                            <strong v-else class="fs-12">
                                {{ $filters.price(cancellationItem.price) }}
                            </strong>
                            <slot name="hotelPriceNote" />
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider
                        v-if="index < conditionsInfo.cancellationItems.length - 1 || conditionsInfo.errors"
                        :key="index + '_1'"
                    />
                </template>
                <v-list-item v-if="authStore.settings?.serverTimeZone" density="compact" class="text-caption">
                    * {{ $t('by_timezone') }} ({{ authStore.settings.serverTimeZone }})
                </v-list-item>
                <v-list-item v-for="(error, index) in conditionsInfo.errors" :key="index" class="text-caption pb-2">
                    <span class="text-warning">{{ error }}</span>
                </v-list-item>
            </v-list>
            <v-card-text v-else class="text-center pt-2 pb-6">
                {{ $t('empty_conditions_message') }}
            </v-card-text>
        </v-card>
    </div>
</template>

<script lang="ts">
    import {Component, mixins, Prop} from 'vue-facing-decorator'
    import {ConditionsMixin} from '@/components/mixins/ConditionsMixin.vue'
    import HotelPriceNote from '@/components/hotels/snippets/HotelPriceNote.vue'

    @Component({
        components: {HotelPriceNote},
    })
    export class Conditions extends mixins(ConditionsMixin) {
        @Prop({type: Boolean}) disableCurrencyConversion
        @Prop() offer
        @Prop() offerKey
        @Prop() conditionsInfoData
        @Prop({default: false, type: Boolean}) hideCloseBtn
        @Prop({default: false, type: Boolean}) hideTitle
        @Prop({default: 1, type: Number}) elevation

        get conditionsInfo() {
            return this.offerKey ? persistentStore.conditions[this.offerKey] : this.conditionsInfoData
        }

        get isLoading() {
            return this.offerKey ? runtimeStore.isConditionsLoading(this.offerKey) : false
        }

        get userTimeZone() {
            return authStore.userTimeZone
        }
    }

    export default Conditions
</script>

<style>
    .fs-14 {
        font-size: 14px !important;
    }
    .fs-12 {
        font-size: 12px;
    }
</style>
